module.exports = __webpack_public_path__ + "static/images/c-home__section--dark_pattern.300a71bfc8253cc4097054e025e08d73.png";